import { z } from 'zod'

export const documentStatusSchema = z.enum(['initial', 'ocrFailed', 'ocrCompleted', 'reviewPending', 'confirmed'])
export type DocumentStatus = z.infer<typeof documentStatusSchema>

export const documentStatusLabels: Record<DocumentStatus, string> = {
  initial: 'OCR処理中',
  ocrFailed: 'OCR失敗',
  ocrCompleted: 'OCR完了',
  // admin側の事前レビューが完了し、顧客の確認待ち
  reviewPending: 'レビュー済み',
  confirmed: '確認済み',
}

// antd Tag の color プリセット
export const documentStatusColors: Record<DocumentStatus, string> = {
  initial: 'processing',
  ocrFailed: 'error',
  ocrCompleted: 'warning',
  reviewPending: 'default',
  confirmed: 'success',
}
